module.exports = {
  "country": "CH",
  "artist": "DJ Bobo",
  "song": "Vampires Are Alive",
  "year": "2007",
  "place": "NQ",
  "spotify": "7EHRgSmiO0bjcZ1ulKcsX7"
};